module.exports = __webpack_public_path__ + "media/ad.06b40968.mp4";